<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.employee.leaveRecord.leaveRecord') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('administration.employee.leaveRecord.leaveRecord'),
            href: '/employees'
          },
          {
            text: $t('add_new'),
            active: true
          }
        ]"
      />
    </div>
    <form class="form-horizontal">
      <div class="row">
        <div class="col-lg-3 col-md-5 col-sm-12">
          <ts-card>
            <div id="cover-image">
              <img
                src="http://img.clipartlook.com/office-management-clipart-business-presentation-information-clip-art-vector-business-office-meeting-2694.png"
                alt=""
              />
              <div id="img-frame" class="text-center mb-1">
                <img :src="photoEmp(profile)" @error="onError(profile)" />
              </div>
            </div>
            <div class="row form-group m-b-15">
              <div class="col-md-12 text-center">
                <span>{{ profile.emp_id }}</span>
                <h3
                  class="text-center ts-font-bold ts-text-lg mt-2 mb-0 text-uppercase text-primary"
                >
                  {{ profile.name_en }}
                </h3>
                <small class="text-center text-default">
                  {{ profile.pos_name_en }}
                </small>
              </div>
            </div>
            <ts-card-wrapper>
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                  <span>{{
                    $t('administration.employee.leaveRecord.nameKh')
                  }}</span>
                  <p class="pull-right">
                    {{ profile.name_kh ? profile.name_kh : '-' }}
                  </p>
                </li>
                <li class="list-group-item">
                  <span>{{
                    $t('administration.employee.leaveRecord.nameEn')
                  }}</span>
                  <p class="pull-right">
                    {{ profile.name_en ? profile.name_en : '-' }}
                  </p>
                </li>
                <li class="list-group-item">
                  <span>{{
                    $t('administration.employee.leaveRecord.gender')
                  }}</span>
                  <p class="pull-right">
                    {{ profile.gender ? profile.gender : '-' }}
                  </p>
                </li>
                <li class="list-group-item">
                  <span>{{
                    $t('administration.employee.leaveRecord.dateOfBirth')
                  }}</span>
                  <p class="pull-right">
                    {{ profile.date_of_birth ? profile.date_of_birth : '-' }}
                  </p>
                </li>
                <li class="list-group-item">
                  <span>{{
                    $t('administration.employee.leaveRecord.shiftName')
                  }}</span>
                  <p class="pull-right">
                    {{ profile.shift_name ? profile.shift_name : '-' }}
                  </p>
                </li>
              </ul>
            </ts-card-wrapper>
          </ts-card>
          <br />
        </div>
        <div class="col-lg-9 col-md-7 col-sm-12">
          <ts-card>
            <ts-loading-banner :loading="loadingPreData">
              <ts-card-wrapper>
                <div class="row form-group m-b-15">
                  <label class="col-sm-3 col-form-label control-label required">
                    {{ $t('administration.employee.leaveRecord.employeeName') }}
                  </label>
                  <div class="col-sm-6">
                    <ts-search-select
                      v-model="model.staff_id"
                      @change="getEmployee"
                      :class="{ 'is-invalid': errors.has('staff_id') }"
                      :options="
                        employees.map(emp => ({
                          value: emp.staff_id,
                          text: emp.name_en + ' | ' + emp.name_kh
                        }))
                      "
                    />
                    <div class="invalid-feedback" v-if="errors.has('staff_id')">
                      {{ errors.first('staff_id') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-15">
                  <label class="col-sm-3 control-label required">{{
                    $t('administration.employee.leaveRecord.leaveType')
                  }}</label>
                  <div class="col-sm-6">
                    <select
                      class="form-control"
                      v-model="model.leave_type_id"
                      :class="{ 'is-invalid': errors.has('leave_type_id') }"
                    >
                      <option value="" disabled selected style="display: none;">
                        {{ $t('select') }}</option
                      >
                      <option
                        v-for="(leave_type, index) in leaveTypes"
                        :key="index"
                        :value="leave_type.leave_type_id"
                      >
                        {{ leave_type.leave_type }} |
                        {{ leave_type.leave_type_kh }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('leave_type_id')"
                    >
                      {{ errors.first('leave_type_id') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row m-b-15">
                  <label class="col-md-3 col-form-label control-label required">
                    {{ $t('administration.employee.leaveRecord.dateFrom') }}
                  </label>
                  <div class="col-md-6 col-xs-12">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <ts-date-picker-input
                        v-model="model.date_from"
                        @input="onValueChange"
                        :class="{ 'is-invalid': errors.has('date_from') }"
                      ></ts-date-picker-input>
                      <label
                        class="col-md-4 col-sm-4 col-lg-4 col-form-label control-label required"
                      >
                        {{ $t('administration.employee.leaveRecord.dateTo') }}
                      </label>
                      <ts-date-picker-input
                        v-model="model.date_to"
                        @input="onValueChange"
                        :class="{ 'is-invalid': errors.has('date_to') }"
                      ></ts-date-picker-input>
                    </div>
                  </div>
                </div>
                <div class="form-group row m-b-15">
                  <label class="col-md-3 col-form-label control-label required">
                    {{ $t('administration.employee.leaveRecord.timeFrom') }}
                  </label>
                  <div class="col-md-6 col-xs-12">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div class="input-group">
                        <select
                          :class="{ 'is-invalid': errors.has('time_from') }"
                          class="form-control"
                          v-model="model.time_from"
                          @change="onValueChange"
                        >
                          <option
                            :value="null"
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}</option
                          >
                          <option
                            v-for="(time, index) in times"
                            :key="index"
                            :value="time.time_from"
                            >{{ tConvert(time.time_from) }}
                          </option>
                        </select>
                        <span class="input-group-addon">
                          <span class="fa fa-clock"></span>
                        </span>
                      </div>
                      <label
                        class="col-md-4 col-sm-4 col-lg-4 col-form-label control-label required"
                      >
                        {{ $t('administration.employee.leaveRecord.timeTo') }}
                      </label>
                      <div class="input-group">
                        <select
                          :class="{ 'is-invalid': errors.has('time_to') }"
                          class="form-control"
                          v-model="model.time_to"
                          @change="onValueChange"
                        >
                          <option
                            :value="null"
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}</option
                          >
                          <option
                            v-for="(time, index) in availableTimeTos"
                            :key="index"
                            :value="time.time_to"
                          >
                            {{ tConvert(time.time_to) }}
                          </option>
                        </select>
                        <span class="input-group-addon">
                          <span class="fa fa-clock"></span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <label
                    v-if="model.total_day"
                    class="col-md-3 text-center text-primary"
                  >
                    {{ $t('administration.employee.leaveRecord.totalLeave') }}:
                    {{
                      model.total_day > 1
                        ? model.total_day +
                          $t('administration.employee.leaveRecord.days')
                        : model.total_day +
                          $t('administration.employee.leaveRecord.day')
                    }}
                  </label>
                </div>
                <div class="form-group row m-b-15">
                  <label for="leave_reason" class="col-sm-3 control-label">
                    {{ $t('administration.employee.leaveRecord.leaveReason') }}
                  </label>
                  <div class="col-sm-6">
                    <textarea
                      id="leave_reason"
                      v-model="model.leave_reason"
                      class="form-control"
                      rows="5"
                      :placeholder="
                        $t(
                          'administration.employee.leaveRecord.writeReasonHere'
                        )
                      "
                    ></textarea>
                  </div>
                </div>
                <hr />
                <div class="row mt-3">
                  <div class="col-md-12 text-right">
                    <ts-button
                      class="btn-default mr-2"
                      @click="$router.push({ name: 'leave-record' })"
                    >
                      {{ $t('cancel') }}
                    </ts-button>
                    <ts-button
                      outline
                      color="primary"
                      class="mr-2"
                      @click.prevent="saveNew"
                      :waiting="saving_new"
                    >
                      {{ $t('save_add_new') }}
                    </ts-button>
                    <ts-button
                      class="btn-primary"
                      @click.prevent="save"
                      :waiting="saving"
                    >
                      {{ $t('save') }}
                    </ts-button>
                  </div>
                </div>
              </ts-card-wrapper>
            </ts-loading-banner>
          </ts-card>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'leave-record-create',
  data() {
    return {
      model: {
        staff_id: '',
        leave_type_id: '',
        date_from: moment().format('D-MM-YYYY'),
        date_to: moment().format('D-MM-YYYY'),
        time_from: null,
        time_to: null,
        total_day: null,
        leave_reason: ''
      },
      profile: {
        emp_id: '',
        name_en: '',
        name_kh: '',
        gender: '',
        pos_name_en: '',
        shift_name: '',
        date_of_birth: '',
        photo: '',
        phone_line_1: ''
      },
      errors: new Errors(),
      saving: false,
      saving_new: false,
      loadingPreData: false,
      manPhoto: require('../../assets/staff-default-man.png'),
      womenPhoto: require('../../assets/staff-default-women.png'),
      user_default: require('../../assets/user_default.png')
    }
  },
  computed: {
    ...mapState('leaveRecord', ['employees', 'leaveTypes', 'times']),
    availableTimeTos() {
      let duration = moment.duration(
        moment(this.model.date_to, 'D-MM-YYYY').diff(
          moment(this.model.date_from, 'D-MM-YYYY')
        )
      )

      if (duration._milliseconds > 0) {
        return this.times.filter(el => el.time_to != null)
      } else if (duration._milliseconds < 0) {
        this.$store.commit('leaveRecord/RECEIVE_TIMES', [])
        this.model.time_from = this.model.time_to = null
      } else {
        let time = []
        this.times.forEach(data => {
          time.push(
            Object.assign({}, this.newItem, data, {
              time_to:
                moment(this.tConvert(data.time_to), 'HH:mm a') >
                  moment(this.tConvert(this.model.time_from), 'HH:mm a') ||
                this.model.time_from === null
                  ? data.time_to
                  : null
            })
          )
        })
        return time.filter(el => el.time_to != null)
      }
    }
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    ...mapActions('leaveRecord', ['fetchEmployees', 'getTimeFromTo']),

    onValueChange() {
      this.model.total_day = null
      this.getTimeFromTo(this.model)
      this.getTotalDay()
    },

    getTotalDay() {
      if (
        !this.model.staff_id ||
        !this.model.date_from ||
        !this.model.date_to ||
        !this.model.time_from ||
        !this.model.time_to
      )
        return
      this.$store
        .dispatch('leaveRecord/getTotal', this.model)
        .then(response => {
          this.model.total_day = response.data[0].totalday
        })
    },

    tConvert(time) {
      if (time === null || time === undefined) return null
      // Check correct time format and split into components
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time]

      if (time.length > 1) {
        // If time format correct
        time = time.slice(1) // Remove full string match value
        time[5] = +time[0] < 12 ? ' AM' : ' PM' // Set AM/PM
        time[0] = +time[0] % 12 || 12 // Adjust hours
      }
      return time.join('') // return adjusted time or original string
    },

    async fetchResourceBeforeCreate() {
      this.loadingPreData = true
      await Promise.all([this.fetchEmployees()]).then(() => {})
      await this.$store
        .dispatch('leaveRecord/dataBeforeCreate')
        .then(() => {
          this.loadingPreData = false
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    getEmployee(staff_id) {
      if (staff_id === null || staff_id === undefined) return

      let employee = this.employees.find(e => e.staff_id == staff_id)

      if (employee === null || employee === undefined) return
      this.profile.emp_id = employee.emp_id
      this.profile.name_en = employee.name_en
      this.profile.name_kh = employee.name_kh
      this.profile.gender = employee.gender
      this.profile.pos_name_en = employee.position
        ? employee.position.pos_name_en
        : ''
      this.profile.shift_name = employee.shift
        ? employee.shift.shift_name + '(' + employee.shift.shift_type + ')'
        : ''
      this.profile.date_of_birth = employee.date_of_birth
      this.profile.photo = employee.photo
      this.profile.phone_line_1 = employee.phone_line_1
      this.getTimeFromTo(this.model)
      this.getTotalDay()
    },
    photoEmp(record) {
      if (!this.model.staff_id) return this.user_default
      if (record.photo) {
        return record.photo
      }
      return record.gender == 1 ? this.manPhoto : this.womenPhoto
    },

    onError(record) {
      event.target.src = record.gender == 1 ? this.manPhoto : this.womenPhoto
    },
    save() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('leaveRecord/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'leave-record' })
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    saveNew() {
      this.errors = new Errors()
      this.saving_new = true
      this.$store
        .dispatch('leaveRecord/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.saving_new = false
        })
        .catch(error => {
          this.saving_new = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    clearInput() {
      ;(this.model = {
        staff_id: '',
        leave_type_id: '',
        date_from: moment().format('D-MM-YYYY'),
        date_to: moment().format('D-MM-YYYY'),
        time_from: null,
        time_to: null,
        total_day: null,
        leave_reason: ''
      }),
        (this.profile = {
          emp_id: '',
          name_en: '',
          name_kh: '',
          gender: '',
          pos_name_en: '',
          shift_name: '',
          date_of_birth: '',
          photo: '',
          phone_line_1: ''
        })
    }
  },
  watch: {},
  beforeRouteLeave(to, from, next) {
    this.$store.commit('leaveRecord/RESET_STATE')
    next()
  }
}
</script>
<style scoped>
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.section-divider {
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.list-group-item {
  border: none !important;
  padding: 15px 0 15px 0;
  margin: 0;
  border-top: 1px solid #eee !important;
}
.list-group-item.address {
  border: none !important;
  padding-top: 2px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin: -19%;
}
#img-frame img {
  object-fit: contain;
  width: 20%;
  height: 20%;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
